import React from 'react';
import Nav from '../components/Nav';
import Posts_s from '../components/Posts_s';
import { database } from '../firebase';
import './../css/App.css';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.database = database.ref("users")
  }

  componentDidMount() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 13) document.getElementById("ara-men").click()
    });

    var value0 = window.location.search.slice(3);
    //var value1 = value0.replace(/%20/g, " ")
    var value1 = decodeURIComponent(value0)
    document.getElementById("arama").value = value1;
  }

  functions() {
    if (document.getElementById("arama").value !== "") 
      window.location = window.location.pathname+`?q=`+document.getElementById("arama").value; 
  }

  render() {return (
    <>
      <Nav activeItem="search"/>
      <div className="hero">
        <p className="asdf">Aradığın Yazıyı Bul</p>
        <p className="asdf2">Tüm yazılar burada, yazarlardan halka.</p>
        <div className="search-div">
          <input type="search" id="arama" placeholder="Yazılarda Ara"></input>
          <button id="ara-men" onClick={this.functions}><img src="/search-icon-light.png"/></button>
        </div>
      </div>

      <div className="main">
        <Posts_s/>
      </div>

      <style>{`
        .main {
          padding: 25px 0px 52px;
        }

        .a {
          color: #00a0d9;
          font-size: 25px;
        }
       
        .hero {
          background: url(/sss-banner.jpg);
          background-size: cover;
          padding: 100px 100px;
          margin-top: 50px;
          text-align: center;
        }
  
        .asdf {
          color: #fff;
          text-align: center;
          margin: 0;
          padding: 0 0 5px;
          font-size: 24px;
          font-weight: bold;
        }

        .asdf2 {
          color: #fff;
          text-align: center;
          margin: 0;
          padding: 0 0 10px;
          font-size: 15px;
        }

        .search-div {
          margin: 0 auto;
          width: max-content;
          display: flex;
        }

        input {
          padding-left: 15px;
          border: 0;
          border: 5px solid #2f2d33;
          border-radius: 20px 0 0 20px;
          width: 300px;
          height: 40px;
          outline: none;
          transition: .2s;
        }
    
        input:focus {
          border: 5px solid #F57029;
        }
      
        input:focus ~ button {
          background: #F57029;
        }

        button {
          height: 40px;
          padding: 1px 25px 1px 15px;
          border: none;
          border-radius: 0 20px 20px 0;
          background: #2f2d33;
          color: #fff;
          outline: none;
          transition: .2s;
        }
        
        button:focus {
          background: #F57029;
        }

        button img {
          width: 25px;
        }

        .error_p {
          text-align: center;
          font-size: 30px;
        }

        @media (max-width: 900px) {
          .hero {
            width: 100%;
            margin: 0;
          }
        }
  
        @media (max-width: 623px) {
         .main {
           padding: 40px 0px 52px;
         }
  
         .hero {
           width: 100%;
           margin: 0;
           padding: 0;
         }

         .asdf {
           display: none;
         }
         
         .asdf2 {
           display: none;
         }

         .search-div {
           margin: 0px auto;
           width: 100%;
           max-width: 100%;
           box-shadow: 0 0 20px 0px rgb(0 0 0 / 30%);
           position: fixed;
           z-index: 10;
         }
         
         #arama {
           width: 80%;
           border-radius: 0;
         }

         #ara-men {
           width: 20%;
           border-radius: 0;
         }
        }
      `}</style>
    </>
    );
}};

export default Search;